import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Ad from '../../../../components/ad/ad';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import AllFeed from '../../../../components/all_feed/all_feed';
import PersonCompanyComponent from '../../../../components/person_company_component/person_company_component';
import { tagAllFeedAllStoriesRendered } from '../../../../../redux/action_creators/tag/tag_all_feed_action_creators';
import loadData from './company_page_state_manager';
import { canUseDOM } from 'exenv';

// eslint-disable-next-line react/prefer-stateless-function
class Company extends Component {
  static loadData(store) {
    return loadData(store);
  }

  componentDidMount() {
    const adData = get(this.props.companyPage, 'ads');

    if (canUseDOM) {
      if (adData !== undefined) {
        // Update the data layer
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/${adData.model.adzone}`
        });
      }
    }
  }

  render() {
    const {
      status,
      config,
      companyPage,
      company,
      companyData,
      companyAwards,
      tagAllFeed
    } = this.props;

    if (status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (companyPage.isLoading) {
      return (
        <section className="company-page">
          <article className="company-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(companyPage, 'ads');

    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    const fullName = get(company, 'name');

    return (
      <section className="company-page">
        <Ad
          {...combinedAdModel}
          name="mobileleaderboard_short"
          region="articletop"
          pos="atf"
        />
        {/* <Ad {...combinedAdModel} name="oop" slug={false} oop /> */}
        <div className="company-page__top-ad-container">
          <Ad
            {...combinedAdModel}
            name="flexiblebillboard_1"
            noLazyLoad={true}
          />
          <Ad {...combinedAdModel} name="mobilerectangle_1" noLazyLoad={true} />
        </div>
        <PersonCompanyComponent
          personOrCompany={companyData}
          type="company"
          awards={companyAwards}
        />
        {get(tagAllFeed, 'posts[0]') ? (
          <AllFeed
            adModel={combinedAdModel}
            stories={get(tagAllFeed, 'posts')}
            allRendered={true}
            updateAction={tagAllFeedAllStoriesRendered}
            config={config}
            titleOverride={`Stories about ${fullName}`}
          />
        ) : (
          ''
        )}
        {get(this.props, 'tagAllFeed.posts[0]') ? (
          <div className="company-page__ad-container">
            <Ad
              {...combinedAdModel}
              name="flexiblebillboard_1"
              noLazyLoad={true}
            />
            <Ad
              {...combinedAdModel}
              name="mobilerectangle_1"
              noLazyLoad={true}
            />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    company: get(state, 'company.data.rows[0]', {}),
    companyData: get(state, 'companyData.data.rows[0]', {}),
    companyAwards: get(state, 'companyAwards.data.rows', {}),
    companyPage: get(state, 'companyPage', {}),
    tagAllFeed: {
      totalPosts: get(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: get(state, 'tagAllFeed.data.allRendered', false),
      posts: get(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Company.propTypes = {
  status: PropTypes.number,
  config: PropTypes.shape({}).isRequired,
  company: PropTypes.shape({}).isRequired,
  companyAwards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  companyData: PropTypes.shape({}).isRequired,
  companyPage: PropTypes.shape({
    ads: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  tagAllFeed: PropTypes.shape({
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number,
    allRendered: PropTypes.bool,
    posts: PropTypes.arrayOf(PropTypes.shape({}))
  })
};

Company.defaultProps = {
  status: 200,
  companyPage: PropTypes.shape({
    isLoading: false,
    error: false,
    errorMessage: 'Error in companyPage props'
  }),
  tagAllFeed: PropTypes.shape({
    posts: [{}],
    allRendered: false
  })
};

export default withRouter(connect(mapStateToProps)(Company));
